import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Head from '../components/head'

const App = () => {
  return(
    <Layout>
      <Head title="Home" />
      <h1>Hello</h1>
      <h2>I'm Ryan from California!</h2>
    </Layout>
  )
}

export default App;


